export class ErrorMessageService {
    constructor() {
        'ngInject';
        this.errorMessages = {
            required: 'Please fill out all required information.',
            requiredAndInvalid: 'Please review your information and correct any errors.',
            invalid: 'Please correct your information.'
        };
    }

    getMessage(errors) {
        if (!errors.length) return '';
        if (errors.includes('required')) {
            if(errors.length === 1) return this.errorMessages.required;
            return this.errorMessages.requiredAndInvalid;
        }

        return this.errorMessages.invalid;
    }
}
